export default "__VITE_ASSET__BtiPzPas__"